module.exports = __webpack_public_path__ + "static/img/bg-es.fe4aad04.png";